/*
* Developed for G.J. Gardner Homes by Softeq Development Corporation
* http://www.softeq.com
*/

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const EomReportMethod = createEnum('EOM_REPORTS_METHOD', {
  PrintedOnSelectedPrinter: 'PRINT',
  EmailedToCorporateOffice: 'EMAIL_TO_CORPORATE',
  EmailedToMasterOffice: 'EMAIL_TO_MASTER',
});

export type EomReportMethod = EnumSet<typeof EomReportMethod>;

export type EomReportsHistory = {
  id?: ID;
  contractDateJobsCount?: number;
  finalizedJobsCount?: number;
  forMonth: number;
  forYear: number;
  traffic?: number;
  noOfLeads?: number;
  noOfSales?: number;
  noOfStaff?: number;
  staffHoursPaid?: number;
  notProceedingDppJobsCount?: number;
  memo?: string;
  version?: number;
  whs: boolean;
  whsDetails?: string;
};

export type EomReportDto = WithOptimisticLock<{
  id: ID;
  forMonth: number;
  forYear: number;
  method: EomReportMethod;
  printerId: ID;
  authCode: string;
  reconciledBanksAccounts: boolean;
  enteredJobExpenses: boolean;
  finalizedJobsConfirmed: boolean;
  finalizedJobsCount: number;
  lockedDatesInXero: boolean;
  notProceedingDpp: boolean;
  notProceedingDppJobsCount: number;
  contractDates: boolean;
  contractDateJobsCount: number;
  checkedWorkInProgress: boolean;
  checkedSalesManagement: boolean;
  noOfLeads: number;
  noOfSales: number;
  countedTraffic: boolean;
  trafficValue: number;
  advisedStaffFigures: boolean;
  noOfStaff: number;
  staffHoursPaid: number;
  memo: string;
  monthlyDeposit: boolean;
  monthlySlabs: boolean;
  monthlyContracts: boolean;
  jobProfitFinalized: boolean;
  profitOfFinalizedJobs: boolean;
  salesProfitForecast: boolean;
  franchiseMonthly: boolean;
  wip: boolean;
  version: number;
  whs: boolean;
  whsDetails?: string;
  historyEomSettings: EomReportsHistory[];
  eomTaskId?: ID;
}>;
